import NotificationCard from "./notification-table/NotificationCard";
import { NotificationsUIProvider } from "./NotificationsUIContext";

export function NotificationPage({ history }) {
  return (
    <NotificationsUIProvider>
      <NotificationCard />
    </NotificationsUIProvider>
  );
}
